import { Component, inject } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

export enum DeinstagModalResult {
	CONFIRM,
	DECLINE,
}

@Component({
	selector: 'app-deinstag-modal',
	imports: [IonicModule, TranslateModule],
	templateUrl: './deinstag-modal.component.html',
	styleUrl: './deinstag-modal.component.css',
	standalone: true,
})
export class DeinstagModal {
	private modalCtrl = inject(ModalController);

	static async show(modalCtrl: ModalController): Promise<DeinstagModalResult> {
		console.log('DeinstagModal.show()');
		const modal = await modalCtrl.create({
			component: DeinstagModal,
			cssClass: 'deinstag-modal',
		});
		await modal.present();
		const result = (await modal.onDidDismiss()).data as DeinstagModalResult;
		if (!!result) {
			return DeinstagModalResult.DECLINE;
		}
		return result;
	}

	onConfirmClick() {
		this.modalCtrl.dismiss(DeinstagModalResult.CONFIRM);
	}
	onDeclineClick() {
		this.modalCtrl.dismiss(DeinstagModalResult.DECLINE);
	}
}
